import RequestAbstract from "./RequestAbstract";

export default class TreatmentPlans extends RequestAbstract {
    get link() {
        return this.links.treatmentPlans;
    }

    getForClient(clientId) {
        const arr = [
            { field: "clientId", op: "=", value: clientId },
        ];

        return this.getAllFiltered([arr]);
    }

}
